import { memo } from "react";

/**
 * Hand-drawn math/science symbols layered faintly behind the hero.
 * Pure SVG/text, no external assets. Each item is absolutely positioned.
 */
function Chalkboard() {
  return (
    <div className="sm-chalkboard" aria-hidden>
      <span className="formula font-heading" style={{ top: "12%", left: "4%",  fontSize: 64 }}>E = mc²</span>
      <span className="formula font-heading" style={{ top: "38%", left: "5%",  fontSize: 28 }}>c² = a² + b²</span>
      <span className="formula font-heading" style={{ top: "58%", left: "3%",  fontSize: 36 }}>√x</span>
      <span className="formula font-heading" style={{ top: "78%", left: "8%",  fontSize: 22 }}>∑ aₙ</span>

      <span className="formula font-heading" style={{ top: "8%",  right: "5%", fontSize: 32 }}>∫ x dx = x²/2 + C</span>
      <span className="formula font-heading" style={{ top: "44%", right: "4%", fontSize: 26 }}>x = (-b ± √(b²-4ac)) / 2a</span>
      <span className="formula font-heading" style={{ top: "70%", right: "6%", fontSize: 22 }}>H − O − H</span>
      <span className="formula font-heading" style={{ top: "85%", right: "10%", fontSize: 24 }}>π · r²</span>

      <span className="formula font-heading" style={{ top: "26%", left: "18%", fontSize: 18 }}>θ</span>
      <span className="formula font-heading" style={{ top: "50%", left: "22%", fontSize: 18 }}>Δy/Δx</span>
      <span className="formula font-heading" style={{ top: "30%", right: "24%", fontSize: 18 }}>σ</span>
      <span className="formula font-heading" style={{ top: "62%", right: "22%", fontSize: 18 }}>N≡C</span>

      {/* Triangle */}
      <svg className="science" style={{ top: "32%", left: "10%", width: 140, height: 100 }} viewBox="0 0 140 100">
        <polygon points="10,90 70,10 130,90"/>
        <text x="2" y="100" fontSize="10" fill="currentColor" stroke="none">a</text>
        <text x="78" y="60" fontSize="10" fill="currentColor" stroke="none">c</text>
        <text x="120" y="100" fontSize="10" fill="currentColor" stroke="none">b</text>
      </svg>

      {/* Atom */}
      <svg className="science" style={{ top: "12%", right: "12%", width: 110, height: 110 }} viewBox="0 0 110 110">
        <circle cx="55" cy="55" r="6"/>
        <ellipse cx="55" cy="55" rx="48" ry="18"/>
        <ellipse cx="55" cy="55" rx="48" ry="18" transform="rotate(60 55 55)"/>
        <ellipse cx="55" cy="55" rx="48" ry="18" transform="rotate(120 55 55)"/>
      </svg>

      {/* Beaker */}
      <svg className="science" style={{ bottom: "8%", left: "2%", width: 70, height: 90 }} viewBox="0 0 70 90">
        <path d="M22 4 L48 4 L48 30 L62 80 Q35 92 8 80 L22 30 Z"/>
        <line x1="14" y1="60" x2="56" y2="60"/>
        <line x1="18" y1="70" x2="52" y2="70"/>
      </svg>

      {/* Pie chart */}
      <svg className="science" style={{ top: "44%", right: "14%", width: 80, height: 80 }} viewBox="0 0 80 80">
        <circle cx="40" cy="40" r="28"/>
        <line x1="40" y1="40" x2="40" y2="12"/>
        <line x1="40" y1="40" x2="64" y2="56"/>
      </svg>

      {/* Bar chart */}
      <svg className="science" style={{ bottom: "4%", right: "4%", width: 120, height: 70 }} viewBox="0 0 120 70">
        <line x1="0" y1="64" x2="120" y2="64"/>
        <rect x="6"  y="40" width="14" height="24"/>
        <rect x="28" y="28" width="14" height="36"/>
        <rect x="50" y="20" width="14" height="44"/>
        <rect x="72" y="14" width="14" height="50"/>
        <rect x="94" y="8"  width="14" height="56"/>
      </svg>
    </div>
  );
}

export default memo(Chalkboard);
